export const ApplicationOpened = 'ApplicationOpened'
// Auth
export const LoginInitiated = 'Login Initiated'
export const LoginSuccessful = 'Login Successful'
// Shifts
export const ShiftPostedFromTemplate = 'Shift Posted From Template'
export const ShiftPostedFromTemplateError = 'Shift Posted From Template Error'
export const ShiftPostedFromTemplateNavbar = 'Shift Posted From Template Navbar'
export const ShiftPostedFromTemplateNavbarError =
  'Shift Posted From Template Navbar Error'
export const ShiftPostedFromDuplicateModal = 'Shift Posted From Copy'
export const ShiftPostedFromDuplicateModalError = 'Shift Posted From Copy Error'
export const ShiftPostedFromDraft = 'Shift Posted From Draft'
export const ShiftPostedFromDraftError = 'Shift Posted From Draft Error'
export const ShiftPostedFromFullEditDraft = 'Shift Posted From Full Edit Draft'
export const ShiftPostedFromFullEditDraftError =
  'Shift Posted From Full Edit Draft Error'
export const ShiftPostedFromFullEdit = 'Shift Posted From Full Edit'
export const ShiftPostedFromFullEditError = 'Shift Posted From Full Edit Error'
export const BusinessUserWithoutActiveShifts =
  'Business User With No Active Shifts'
// Dashboard Views
export const DashboardTimelineViewed = 'Dashboard Timeline Viewed'
export const DashboardListViewed = 'Dashboard List Viewed'
export const DashboardActionsRequiredViewed =
  'Dashboard Actions Required Viewed'
// Dashboard Feature Announcements
export const DashboardFeatureAnnouncementViewed =
  'Dashboard Feature Announcement Viewed'
// Dashboard Actions
export const DashboardApplicantAccepted = 'Dashboard Applicant Accepted'
export const DashboardApplicantDeclined = 'Dashboard Applicant Declined'
export const DashboardUpshifterClockedIn = 'Dashboard Upshifter Clocked In'
export const DashboardUpshifterClockedOut = 'Dashboard Upshifter Clocked Out'
export const DashboardUpshifterReviewed = 'Dashboard Upshifter Reviewed'
// BusinessButtons Actions
export const ApplicantAccepted = 'Applicant Accepted'
export const ApplicantDeclined = 'Applicant Declined'
export const UpshifterClockedIn = 'Upshifter Clocked In'
export const UpshifterClockedOut = 'Upshifter Clocked Out'
export const UpshifterReviewed = 'Upshifter Reviewed'
// SmartPay
export const SmartPayRecommendedRateClicked =
  'SmartPay Recommended Rate Clicked'

export const Events = {
  ApplicationOpened,
  LoginInitiated,
  LoginSuccessful,
  ShiftPostedFromTemplate,
  ShiftPostedFromTemplateError,
  ShiftPostedFromTemplateNavbar,
  ShiftPostedFromTemplateNavbarError,
  ShiftPostedFromDuplicateModal,
  ShiftPostedFromDuplicateModalError,
  ShiftPostedFromDraft,
  ShiftPostedFromDraftError,
  ShiftPostedFromFullEditDraft,
  ShiftPostedFromFullEditDraftError,
  ShiftPostedFromFullEdit,
  ShiftPostedFromFullEditError,
  BusinessUserWithoutActiveShifts,
  DashboardTimelineViewed,
  DashboardListViewed,
  DashboardActionsRequiredViewed,
  DashboardApplicantAccepted,
  DashboardApplicantDeclined,
  DashboardUpshifterClockedIn,
  DashboardUpshifterClockedOut,
  DashboardUpshifterReviewed,
  ApplicantAccepted,
  ApplicantDeclined,
  UpshifterClockedIn,
  UpshifterClockedOut,
  UpshifterReviewed,
  SmartPayRecommendedRateClicked,
  DashboardFeatureAnnouncementViewed,
}
